// This is autogenerated based on the operationIds from the swagger. You probably shouldn't edit this directly!
export enum OperationIds {
	AddInternationalLicensingPayment = 'addInternationalLicensingPayment',
	AddTuitionPayment = 'addTuitionPayment',
	AssignRole = 'assignRole',
	AuthorizeDotNetEventWebhook = 'authorizeDotNetEventWebhook',
	BackgroundCheckProcessingWebhook = 'backgroundCheckProcessingWebhook',
	BulkReassignEvents = 'bulkReassignEvents',
	BulkReassignTeamMembers = 'bulkReassignTeamMembers',
	CancelEnrollment = 'cancelEnrollment',
	CancelInvitation = 'cancelInvitation',
	ChangeEmail = 'changeEmail',
	ChangePassword = 'changePassword',
	CheckCityUniqueness = 'checkCityUniqueness',
	ClonePlaylist = 'clonePlaylist',
	CompleteAgreement = 'completeAgreement',
	CompleteAgreementWebhook = 'completeAgreementWebhook',
	CompleteEnrollmentInvite = 'completeEnrollmentInvite',
	ConfirmAdobeSignWebhook = 'confirmAdobeSignWebhook',
	ConfirmToken = 'confirmToken',
	ConfirmTokenForSignup = 'confirmTokenForSignup',
	CreateAgreement = 'createAgreement',
	CreateCommunity = 'createCommunity',
	CreateEvent = 'createEvent',
	CreateLeadershipTrainingRegistrant = 'createLeadershipTrainingRegistrant',
	CreateLicensingEnrollment = 'createLicensingEnrollment',
	CreateNotification = 'createNotification',
	CreatePlaylist = 'createPlaylist',
	CreatePlaylistItems = 'createPlaylistItems',
	CreateProgram = 'createProgram',
	CreateRegion = 'createRegion',
	CreateRegionContractingHierarchies = 'createRegionContractingHierarchies',
	CreateRegistrant = 'createRegistrant',
	CreateRole = 'createRole',
	CreateStudent = 'createStudent',
	CreateTranscript = 'createTranscript',
	CreateUser = 'createUser',
	DeclineInvitation = 'declineInvitation',
	DeleteAgreement = 'deleteAgreement',
	DeleteEvent = 'deleteEvent',
	DeleteInvoiceSignatureAddress = 'deleteInvoiceSignatureAddress',
	DeleteNotification = 'deleteNotification',
	DeletePayment = 'deletePayment',
	DeletePlaylist = 'deletePlaylist',
	DeletePlaylistItem = 'deletePlaylistItem',
	DeleteRegionContractingHierarchies = 'deleteRegionContractingHierarchies',
	DeleteRole = 'deleteRole',
	DeleteTranscript = 'deleteTranscript',
	EditBusinessEmail = 'editBusinessEmail',
	EditNotification = 'editNotification',
	EditRole = 'editRole',
	EditStudent = 'editStudent',
	EditUserProfile = 'editUserProfile',
	ExpireTeamMember = 'expireTeamMember',
	FavoritePath = 'favoritePath',
	FetchAcademicYears = 'fetchAcademicYears',
	FetchAgreementPreview = 'fetchAgreementPreview',
	FetchAgreementSigningUrl = 'fetchAgreementSigningUrl',
	FetchAgreementStatus = 'fetchAgreementStatus',
	FetchAgreementTemplateFormFields = 'fetchAgreementTemplateFormFields',
	FetchAllFamilies = 'fetchAllFamilies',
	FetchAllPrograms = 'fetchAllPrograms',
	FetchBilling = 'fetchBilling',
	FetchBusinessContent = 'fetchBusinessContent',
	FetchBusinessContentOptions = 'fetchBusinessContentOptions',
	FetchBusinessLearningPath = 'fetchBusinessLearningPath',
	FetchCommunitiesForUser = 'fetchCommunitiesForUser',
	FetchCommunity = 'fetchCommunity',
	FetchCommunityFinancials = 'fetchCommunityFinancials',
	FetchCommunityOptions = 'fetchCommunityOptions',
	FetchCommunitySpecificProgramOptions = 'fetchCommunitySpecificProgramOptions',
	FetchContentDetail = 'fetchContentDetail',
	FetchContentTagOptions = 'fetchContentTagOptions',
	FetchCountries = 'fetchCountries',
	FetchCountryCoordinatorLicensingDetails = 'fetchCountryCoordinatorLicensingDetails',
	FetchCountryCoordinatorTotalBalance = 'fetchCountryCoordinatorTotalBalance',
	FetchCoursesOfStudies = 'fetchCoursesOfStudies',
	FetchDirectorFinancialDetails = 'fetchDirectorFinancialDetails',
	FetchDiscourseConnectRedirectUrl = 'fetchDiscourseConnectRedirectUrl',
	FetchDownloadUrl = 'fetchDownloadUrl',
	FetchEnrollmentBillingPaymentOptions = 'fetchEnrollmentBillingPaymentOptions',
	FetchEnrollmentInvites = 'fetchEnrollmentInvites',
	FetchEnrollments = 'fetchEnrollments',
	FetchEnrollmentStatuses = 'fetchEnrollmentStatuses',
	FetchEvent = 'fetchEvent',
	FetchEventCategories = 'fetchEventCategories',
	FetchEventOptions = 'fetchEventOptions',
	FetchEventRegistrants = 'fetchEventRegistrants',
	FetchEvents = 'fetchEvents',
	FetchFamilyTuitionBilling = 'fetchFamilyTuitionBilling',
	FetchGradingScales = 'fetchGradingScales',
	FetchInternationalCountries = 'fetchInternationalCountries',
	FetchInternationalEvents = 'fetchInternationalEvents',
	FetchInternationalLicensingFilterOptions = 'fetchInternationalLicensingFilterOptions',
	FetchInviteFamilyCommunities = 'fetchInviteFamilyCommunities',
	FetchInviteFamilyPrograms = 'fetchInviteFamilyPrograms',
	FetchInviteTeamMemberOptions = 'fetchInviteTeamMemberOptions',
	FetchInviteValidity = 'fetchInviteValidity',
	FetchInvoiceSignature = 'fetchInvoiceSignature',
	FetchLcdTotalOwed = 'fetchLcdTotalOwed',
	FetchLeadershipTraining = 'fetchLeadershipTraining',
	FetchLearningCenterAvailableProgramTypes = 'fetchLearningCenterAvailableProgramTypes',
	FetchLearningCenterContent = 'fetchLearningCenterContent',
	FetchLearningCenterLearningPath = 'fetchLearningCenterLearningPath',
	FetchLearningCenterOptions = 'fetchLearningCenterOptions',
	FetchLicensedDirectorBillingDetails = 'fetchLicensedDirectorBillingDetails',
	FetchLicensingInternationalPayments = 'fetchLicensingInternationalPayments',
	FetchLicensingLcdPayments = 'fetchLicensingLcdPayments',
	FetchMetric = 'fetchMetric',
	FetchMetrics = 'fetchMetrics',
	FetchNotification = 'fetchNotification',
	FetchNotifications = 'fetchNotifications',
	FetchPaymentOptions = 'fetchPaymentOptions',
	FetchPermissions = 'fetchPermissions',
	FetchPlaylist = 'fetchPlaylist',
	FetchProgram = 'fetchProgram',
	FetchProgramOptions = 'fetchProgramOptions',
	FetchProgramsForUser = 'fetchProgramsForUser',
	FetchPublicEventDetails = 'fetchPublicEventDetails',
	FetchRegion = 'fetchRegion',
	FetchRegionContractingHierarchies = 'fetchRegionContractingHierarchies',
	FetchRegionFees = 'fetchRegionFees',
	FetchRegionOptions = 'fetchRegionOptions',
	FetchRegions = 'fetchRegions',
	FetchRoles = 'fetchRoles',
	FetchSession = 'fetchSession',
	FetchSharePlaylist = 'fetchSharePlaylist',
	FetchShopifyMultipassIdentifier = 'fetchShopifyMultipassIdentifier',
	FetchShopifyMultipassUrl = 'fetchShopifyMultipassUrl',
	FetchStates = 'fetchStates',
	FetchStudents = 'fetchStudents',
	FetchStudentsForFamily = 'fetchStudentsForFamily',
	FetchTeamAgreementsForUser = 'fetchTeamAgreementsForUser',
	FetchTeamForUser = 'fetchTeamForUser',
	FetchTimezones = 'fetchTimezones',
	FetchTranscript = 'fetchTranscript',
	FetchTranscripts = 'fetchTranscripts',
	FetchTuitionInvoice = 'fetchTuitionInvoice',
	FetcHubspotTerritory = 'fetcHubspotTerritory',
	FetchUser = 'fetchUser',
	FetchUserAccountRoles = 'fetchUserAccountRoles',
	FetchUserCommunities = 'fetchUserCommunities',
	FetchUserNdaStatus = 'fetchUserNdaStatus',
	FetchUserNotifications = 'fetchUserNotifications',
	FetchUserPlaylists = 'fetchUserPlaylists',
	FetchUserProfile = 'fetchUserProfile',
	FetchUsers = 'fetchUsers',
	FetchUserScreenings = 'fetchUserScreenings',
	Healthcheck = 'healthcheck',
	HubspotContactCreationWebhook = 'hubspotContactCreationWebhook',
	InviteFamily = 'inviteFamily',
	InviteTeamMember = 'inviteTeamMember',
	Login = 'login',
	LoginForInvite = 'loginForInvite',
	Logout = 'logout',
	LogoutAllSessions = 'logoutAllSessions',
	MarkParchmentAsSent = 'markParchmentAsSent',
	MarkParchmentAsUnsent = 'markParchmentAsUnsent',
	NdaAcknowledgementPath = 'ndaAcknowledgementPath',
	PayByAch = 'payByAch',
	RemoveLicensingEnrollments = 'removeLicensingEnrollments',
	RemoveTuitionPayment = 'removeTuitionPayment',
	ResendInvitation = 'resendInvitation',
	ResendTeamMember = 'resendTeamMember',
	ResetPassword = 'resetPassword',
	SafetyTrainingWebhook = 'safetyTrainingWebhook',
	SearchPossibleEventOwners = 'searchPossibleEventOwners',
	SearchPublicCommunities = 'searchPublicCommunities',
	SearchPublicCommunity = 'searchPublicCommunity',
	SearchPublicEvents = 'searchPublicEvents',
	SearchPublicInternationalCommunities = 'searchPublicInternationalCommunities',
	SearchPublicInternationalCommunity = 'searchPublicInternationalCommunity',
	SendTokenForSignup = 'sendTokenForSignup',
	SendTranscriptToParchment = 'sendTranscriptToParchment',
	SendTuitionInvoice = 'sendTuitionInvoice',
	SetRegionFees = 'setRegionFees',
	SharePlaylist = 'sharePlaylist',
	StarRating = 'starRating',
	StartPayment = 'startPayment',
	SubmitContactForm = 'submitContactForm',
	SyncShopifyDiscounts = 'syncShopifyDiscounts',
	TransferEnrollment = 'transferEnrollment',
	UnassignRole = 'unassignRole',
	UnsharePlaylist = 'unsharePlaylist',
	UpdateCommunity = 'updateCommunity',
	UpdateEnrollmentStatus = 'updateEnrollmentStatus',
	UpdateEvent = 'updateEvent',
	UpdateInvoiceLine = 'updateInvoiceLine',
	UpdateInvoiceSignature = 'updateInvoiceSignature',
	UpdateLicensingEnrollments = 'updateLicensingEnrollments',
	UpdateLicensingInternationalPayment = 'updateLicensingInternationalPayment',
	UpdateLogin = 'updateLogin',
	UpdatePayment = 'updatePayment',
	UpdatePaymentAddress = 'updatePaymentAddress',
	UpdatePlaylistItemsOrder = 'updatePlaylistItemsOrder',
	UpdatePlaylistName = 'updatePlaylistName',
	UpdateProgram = 'updateProgram',
	UpdateRegion = 'updateRegion',
	UpdateRegionContentTags = 'updateRegionContentTags',
	UpdateRegistrant = 'updateRegistrant',
	UpdateRegistrants = 'updateRegistrants',
	UpdateRole = 'updateRole',
	UpdateStudentTutorAssignments = 'updateStudentTutorAssignments',
	UpdateTranscript = 'updateTranscript',
	UpdateTranscriptOnHoldStatus = 'updateTranscriptOnHoldStatus',
	UpdateUser = 'updateUser',
	UpdateUserScreening = 'updateUserScreening',
	ValidateAchRoutingNumber = 'validateAchRoutingNumber',
	ValidateAddress = 'validateAddress',
	ValidateInvitation = 'validateInvitation',
	ValidatePotentialEnrollments = 'validatePotentialEnrollments',    
}